import { useSelector } from 'react-redux'
import { useLoadingActions } from '../store/slices/LoadingSlice'

const useGlobalLoading = (listen = true) => {
    const { changeLoading, changeText } = useLoadingActions()
    const isLoading = useSelector(state =>
        listen ? state.LoadingSlice.loading : false,
    )
    const text = useSelector(state =>
        listen ? state.LoadingSlice.text : 'Loading',
    )

    return {
        changeLoading,
        changeText,
        isLoading,
        text,
    }
}

export default useGlobalLoading
